import { PageCard } from "src/common/styles/styles"
import { SearchableTable } from "src/components/SearchableTable"
import { ColumnsKeys, summaryColumns, TABLE_COLUMNS } from "./config"
import { SystemDescriptions } from "src/common/descriptions"
import { ColumnsType } from "antd/es/table"
import { PayableContract } from "src/common/models/payableContract"
import { useNavigate } from "react-router"
import { Urls } from "src/common/urls"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/state/reducer"
import { serviceLoading } from "src/common/apiLoader/state/selection"
import { GET_PAYABLE_CONTRACTS_API } from "../state/actionTypes"
import { useEffect, useState } from "react"
import { getPayableContractsApi } from "../state/action"
import { searchableTableUtils } from "src/components/SearchableTable/utils"
import { Button, Space, Tooltip } from "antd"
import { ProfileOutlined, EditOutlined } from '@ant-design/icons'
import useUserPermission from "src/hooks/useUserPermissions"
import { USER_SCOPES } from "src/hooks/UserPermission"

export type ReduxProps = {
    payableContracts: PayableContract[],
    isGettingContracts: boolean,
}

export enum ContractView {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export const PayableContracts = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { validateUserScopeForPage } = useUserPermission()

    const [contractsView, setContractsView] = useState(ContractView.ACTIVE)

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        payableContracts: state.payableContract.payableContracts || [],
        isGettingContracts: serviceLoading(state, [GET_PAYABLE_CONTRACTS_API]),
    }))

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.PAYABLE_CONTRACT_READ)
        dispatch(getPayableContractsApi({
            isActive: true,
        }))
    }, [])

    const descriptions = SystemDescriptions.PAGES.PAYABLE_CONTRACT.PAYABLE_CONTRACTS
    const commonDescriptions = SystemDescriptions.PAGES.COMMON

    const tblColumns: ColumnsType<PayableContract> = [
        ...TABLE_COLUMNS,
        {
            title: descriptions.TABLE_COLUMNS.ACTIONS,
            dataIndex: ColumnsKeys.ACTIONS,
            key: ColumnsKeys.ACTIONS,
            align: searchableTableUtils.alignment.centerAlign,
            render: (_, record: PayableContract) => {
                const handleViewClick = (contractId: number) => {
                    navigate(Urls.FRONTEND.PAYABLE_CONTRACT.DETAIL_PAGE(contractId))
                }

                const handleEditClick = () => {
                    navigate(Urls.FRONTEND.PAYABLE_CONTRACT.EDIT_PAGE(record.id!))
                }

                return <Space size="middle">
                    <Tooltip title={commonDescriptions.ACTIONS.VIEW} >
                        <Button type="primary" ghost shape="circle" size="small"
                            icon={<ProfileOutlined />}
                            onClick={() => handleViewClick(record.id!)}
                        />
                    </Tooltip>
                    <Tooltip title={commonDescriptions.ACTIONS.EDIT} >
                        <Button type="primary" ghost shape="circle" size="small"
                            icon={<EditOutlined />}
                            onClick={handleEditClick}
                        />
                    </Tooltip>
                </Space>
            },
        },
    ]

    const handleActionClick = () => {
        navigate(Urls.FRONTEND.ACCOUNT_PAYABLE.CREATE)
    }

    const renderExtra = () => {
        return <Button
            color={contractsView !== ContractView.ACTIVE ? "default" : "danger"}
            variant="filled"
            size="small"
            onClick={() => {
                dispatch(getPayableContractsApi({
                    isActive: contractsView !== ContractView.ACTIVE ? true : false,
                }))

                setContractsView(
                    contractsView === ContractView.ACTIVE
                        ? ContractView.INACTIVE
                        : ContractView.ACTIVE
                )
            }}
        >
            {
                contractsView === ContractView.ACTIVE
                    ? descriptions.VIEW_INACTIVES
                    : descriptions.VIEW_ACTIVES
            }
        </Button>
    }

    return (
        <PageCard
            size="small"
            title={descriptions.TITLE}
            extra={renderExtra()}
        >
            <SearchableTable
                showSearch
                showActionButton
                actionButtonLabel={descriptions.TABLE.ACTION_BUTTON}
                actionButtonOnClick={handleActionClick}
                showLoader={reduxProps.isGettingContracts}
                items={reduxProps.payableContracts}
                tableColumns={tblColumns}
                searchLabel={descriptions.TABLE.SEARCH_PLACEHOLDER}
                summaryColumns={summaryColumns}
            />
        </PageCard>
    )
}
